import { Component, Input } from "@angular/core";

@Component({
  selector: "app-best-scenario-dialog-title",
  templateUrl: "./title.component.html",
})
export class TitleComponent {
  @Input() isPrimary = true;
}
